import {ADVERTISEMENT_PARTNERS} from '../components/AdvertisementAffiliateTile/data';

const resolveAffiliateAdPartners = (isFlagEnabled, variant) => {
  if (!isFlagEnabled) return [];
  if (!variant?.enabled || !variant.payload?.value)
    return ADVERTISEMENT_PARTNERS;

  try {
    const toggles = JSON.parse(variant.payload.value);

    if (!toggles || typeof toggles !== 'object' || Array.isArray(toggles)) {
      return [];
    }

    return ADVERTISEMENT_PARTNERS.filter(partner => toggles[partner] === true);
  } catch (error) {
    return [];
  }
};

export default resolveAffiliateAdPartners;
